import { useQuery } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import { GetOtherEvaluationsResponse, HttpResponse } from "@/types";

export function useGetOtherEvaluations({
  candidacyId,
  talentId,
}: {
  candidacyId?: string | null;
  talentId?: number | null;
}) {
  return useQuery({
    enabled: !!talentId,
    queryKey: ["other-evaluations", candidacyId, talentId],
    queryFn: async () => {
      const queryParams = new URLSearchParams();

      if (candidacyId) {
        queryParams.append("candidacyId", candidacyId);
      }
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      queryParams.append("talentId", talentId!.toString());

      const path = `other-candidacies/evaluations?${queryParams.toString()}`;
      const res = await guacHttpClient.get<
        GetOtherEvaluationsResponse[],
        HttpResponse<GetOtherEvaluationsResponse[]>
      >(path);
      return res.data;
    },
  });
}
